import React from 'react';
import { HiddenText } from './AccessibilityText.styles';

type Props = {
    expanded: boolean;
    editModeActivated: boolean;
};

const AccessibilityText = ({ expanded, editModeActivated }: Props): JSX.Element => {
    let accessibilityText = 'Visas som lista';

    if (expanded) {
        accessibilityText = 'Visas på flera rader';
    }
    if (editModeActivated) {
        accessibilityText =
            'Markera de videor du vill ta bort från listan, gå sedan tillbaka och klicka på klar.';
    }

    return <HiddenText>{accessibilityText}</HiddenText>;
};

export default AccessibilityText;
